// 사용량 경고 메일 값 — 종류·수준은 `0093_usage_mail_log.sql` 의 check 와 같은 순서·값(migrations 테스트가 맞춰 본다).

import type { PlanUsage, UsageMeter } from "./usage-limit";

export const USAGE_MAIL_KINDS = ["storage", "notify"] as const;
export type UsageMailKind = (typeof USAGE_MAIL_KINDS)[number];

export const USAGE_MAIL_LEVELS = ["near", "over"] as const;
export type UsageMailLevel = (typeof USAGE_MAIL_LEVELS)[number];

// 장부 한 줄의 키 — month 는 KST 달 첫날(YYYY-MM-01).
export interface UsageMailKey {
  org_id: string;
  month: string;
  kind: UsageMailKind;
  level: UsageMailLevel;
}

export interface UsageMailOwner {
  org_id: string;
  name: string;
  email: string;
}

// 요금제 칸 주소 한 벌 — 메일 링크·web 띠·카드가 같이 쓴다(설정 첫 탭의 #plan 칸).
export const PLAN_SETTINGS_PATH = "/app/settings#plan";

const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

// 한국 시간 달 첫날 — 서머타임이 없어 9시간만 더한다.
export const kstMonthStartOf = (now: Date): string =>
  new Date(now.getTime() + KST_OFFSET_MS).toISOString().slice(0, 7) + "-01";

// 보낼 (종류, 수준) — ok·한도 없음은 빠진다 · 용량·알림톡 순.
export const usageMailTargets = (usage: PlanUsage): { kind: UsageMailKind; level: UsageMailLevel; meter: UsageMeter }[] => {
  const out: { kind: UsageMailKind; level: UsageMailLevel; meter: UsageMeter }[] = [];
  for (const kind of USAGE_MAIL_KINDS) {
    const meter = usage[kind];
    if (meter.limit === null || meter.level === "ok") continue;
    out.push({ kind, level: meter.level, meter });
  }
  return out;
};
